import { FunctionComponent } from 'react';

import { Box, Typography } from '@mui/material';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { statisticsDataMapped } from '../../utils/consts/statistics-data-mapped.util';
import { StatisticsLegend } from './statistics-legend';

const StatisticsChart: FunctionComponent = () => {
  return (
    <Box
      style={{
        width: '100%',
        height: 400,
        padding: '36px 53px 36px 13px',
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: '300', ml: '12px' }}>
        Timeline
      </Typography>
      <ResponsiveContainer>
        <LineChart
          data={statisticsDataMapped}
          margin={{ top: 30, right: 30, left: 0, bottom: 10 }}
        >
          <CartesianGrid horizontal={false} />
          <XAxis
            dataKey="date"
            tick={{ dy: 10 }}
            tickFormatter={value =>
              new Date(value).toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
              })
            }
          />
          <YAxis />
          <Tooltip
            labelFormatter={label =>
              new Date(label).toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
                year: 'numeric',
              })
            }
          />
          <Legend content={<StatisticsLegend />} />

          <Line
            dataKey="allVersions"
            name="All Versions"
            stroke="#3365ff"
            strokeWidth={4}
            dot={false}
          />
          <Line
            dataKey="android12"
            name="Android 12"
            stroke="#a433ff"
            strokeWidth={3}
            dot={false}
          />
          <Line
            dataKey="android10"
            name="Android 10"
            stroke="#81cb1d"
            strokeWidth={3}
            dot={false}
          />
          <Line
            dataKey="android13"
            name="Android 13"
            stroke="#22d5d0"
            strokeWidth={3}
            dot={false}
          />
          <Line
            dataKey="android9"
            name="Android 9"
            stroke="#ff33af"
            strokeWidth={3}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default StatisticsChart;
